import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api, constants } from "../utils";
import { StatCard } from "./";

export default function DashboardAdmin(props) {
  const [activeUsers, setActiveUsers] = useState({ list: [], pageNumber: 1, totalPages: 1 });

  useEffect(() => {
    loadDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function createPayload() {
    return {
      ActiveOnly: true,
      sortField: null,
      sortDirection: null,
      pageNumber: 1,
      maxResults: constants.C_MAX_INT
    };
  }

  function loadDashboardData() {
    api.post(`Useradmin/List`, createPayload())
      .then(response => {
        if (response && response.data) {
          setActiveUsers(response.data);
        }
      })
      .catch(api.catchHandler);
  }

  return (
    <DesktopContainer screenName={"Admin Dashboard"}>
      <Row className="p-4">
        <Col xs="12" md="9">
          <Row>
            <StatCard
              cardName={"Users"}
              count={activeUsers.list.length}
              link={`/admin/users`}
              xs="3"
            />
          </Row>
        </Col>
      </Row>
    </DesktopContainer>);
}
